import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  fetchUserDtlTrg: 0, // to fetch user detail api
  editUserDetail: false, // used for allowing access and edit of user detail
  glEditUserDetail: false, // used for allowing access and edit of user detail
  hlEditUserDetail: false, // used for allowing access and edit of user detail
  blEditUserDetail: false, // used for allowing access and edit of user detail
  lapEditUserDetail: false, // used for allowing access and edit of user detail
  ccEditUserDetail: false, // used for allowing access and edit of user detail
};

export const tempSlice = createSlice({
  name: "temp",
  initialState,
  reducers: {
    incrementFetchUserDtlTrg: (state) => {
      state.fetchUserDtlTrg += 1;
    },
    updateEditUserDetail: (state, action) => {
      state.editUserDetail = action.payload;
    },
    updateGlEditUserDetail: (state, action) => {
      state.glEditUserDetail = action.payload;
    },
    updateHlEditUserDetail: (state, action) => {
      state.hlEditUserDetail = action.payload;
    },
    updateBlEditUserDetail: (state, action) => {
      state.blEditUserDetail = action.payload;
    },
    updateLapEditUserDetail:(state, action) => {
      state.lapEditUserDetail = action.payload;
    },
    updateCcEditUserDetail:(state, action) => {
      state.ccEditUserDetail = action.payload;
    }
  },
});

// actions export
export const { incrementFetchUserDtlTrg, updateEditUserDetail, updateGlEditUserDetail, updateHlEditUserDetail, updateBlEditUserDetail,updateLapEditUserDetail, updateCcEditUserDetail } =
  tempSlice.actions;

export default tempSlice.reducer;

